<div class="notifications-header">
  <div class="header-content">
    <h3>{{ 'notifications.title' | translate }}</h3>
    <button 
      class="close-button"
      (click)="closeNotifications.emit()"
    >
      <span>×</span>
    </button>
  </div>

  <div class="actions-row">
    <div class="filter-tabs">
      <button 
        [class.active]="selectedFilter === 'all'"
        (click)="onFilterChange('all')"
      >
        {{ 'notifications.filter.all' | translate }}
      </button>
      <button 
        [class.active]="selectedFilter === 'unread'"
        (click)="onFilterChange('unread')"
      >
        {{ 'notifications.filter.unread' | translate }}
      </button>
    </div>

    <button 
      *ngIf="hasUnreadNotifications"
      class="mark-all-read"
      (click)="markAllAsRead.emit()"
    >
      {{ 'notifications.mark_all_as_read' | translate }}
    </button>
  </div>
</div> 